var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('pre',{staticClass:"connection-test",class:_vm.status},[_vm._v(_vm._s(_vm.current))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }